import { postApi } from "./api_instance";

export const signUp = async (
  { companyName, email, password, userType , otp },
  dispatch
) => {
  try {
    const { data } = await postApi({
      apiUrl: "/api/user/signup",
      dispatch,
      data: { name: companyName, email, password, user_type: userType ,otp },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
